export default __webpack_public_path__ + "static/media/Plaza Spa.f285c54c.jpg";